//node_modules
import Image, { StaticImageData } from "next/image";
import { Fragment, FunctionComponent } from "react";
import getBootstrapSizes from "@adjust/website/libs/helper/getBoostrapSizes";
import { css, cx } from "@adjust/libs/emotion";

const sizes = getBootstrapSizes({ xs: 128, sm: 256, md: 384, lg: 640, xl: 750 });

// ==============================
// Image Caption Component
// ==============================

type ImageCaptionProps = {
  caption?: string;
};

const ImageCaptionComponent: FunctionComponent<ImageCaptionProps> = ({ caption }) => {
  if (!caption) return null;

  return <div className={cx("text-muted", "text-center")}>{caption}</div>;
};

// ==============================
// Blog Image Component
// ==============================

type ImageProps = {
  src: StaticImageData;
  alt: string;
  quality?: number;
  height?: 384 | 512 | 750 | 1080;
  objectFit?: "fill" | "contain" | "cover" | "none" | "scale-down";
  caption?: string;
  priority?: boolean;
};

const ImageComponent: FunctionComponent<ImageProps> = ({ src, alt, quality, priority, height, objectFit, caption }) => {
  const imageCSS = css({
    objectFit: objectFit,
  });

  const imageContainer2CSS = css({
    position: "relative",
    margin: "auto",
    height: height || 512,
  });

  return (
    <Fragment>
      <div className={imageContainer2CSS}>
        <Image src={src} alt={alt} className={imageCSS} sizes={sizes} quality={quality} priority={priority} placeholder="blur" fill />
      </div>
      <ImageCaptionComponent caption={caption} />
    </Fragment>
  );
};

export default ImageComponent;
